<template>
  <div class="select select--input">
    <div class="dropdown dropdown--full-width">
      <Popper
        v-model:open="open"
        :modifiers="modifiers"
        placement="bottom-end"
      >
        <template #trigger>
          <div
            class="dropdown__trigger"
            @click="open = !open"
          >
            <div class="select__trigger">
              <span class="select__label select__label--flex select__label--flat">
                <template v-if="modelValue">
                  <template v-if="modelValue.isNew">
                    <span class="menu-item__label-icon">
                      <UseSvg
                        class="icon icon--small"
                        name="plus"
                      />
                    </span>
                    <span class="menu-item__label">
                      {{ labelGroup.newItemLabel }}
                    </span>
                  </template>
                  <template v-else>
                    <UseSvg
                      v-bind="icon"
                      class="menu-item__label-icon"
                    />
                    <span class="menu-item__label">{{ modelValue.name || modelValue.label }}</span>
                  </template>
                </template>
                <span
                  v-else
                  class="dim"
                >{{ labelGroup.noItemLabel }}</span>
              </span>

              <span :class="{ 'select__arrow': true, 'select__arrow--active': open }">
                <UseSvg
                  class="icon icon--small"
                  name="arrow_down_16"
                />
              </span>
            </div>
          </div>
        </template>

        <div class="menu menu--dropdown">
          <ul
            v-if="!showIconsInList"
            class="menu__items"
          >
            <li
              v-if="placeholderAsValue"
              class="menu-item menu-item--dropdown"
            >
              <button
                class="menu-item__link"
                @click="selectItem(null)"
              >
                <span class="menu-item__label dim">
                  {{ labelGroup.noItemLabel }}
                </span>
              </button>
            </li>
            <li
              v-for="item in list"
              :key="item.id"
              class="menu-item menu-item--dropdown"
            >
              <button
                class="menu-item__link"
                @click="selectItem(item)"
              >
                <span class="menu-item__label">
                  {{ item.name || item.label }}
                </span>
              </button>
            </li>
            <li
              v-if="labelGroup?.newItemLabel"
              class="menu-item menu-item--dropdown"
            >
              <button
                class="menu-item__link"
                @click="selectItem(newItem())"
              >
                <UseSvg
                  class="icon icon--small menu-item__label-icon"
                  name="plus"
                />
                <span class="menu-item__label">
                  {{ labelGroup.newItemLabel }}
                </span>
              </button>
            </li>
          </ul>
          <ul
            v-else
            class="menu__items"
            @mouseLeave="hoverItem(null)"
          >
            <SelectItem
              v-for="item in list.filter(x => !x.hidden)"
              :key="item.value"
              :iconsLargeOnRight="true"
              :item="item"
              :labelIcon="showIconsInList ? labelIcons[item.value] : null"
              :selected="item.value === modelValue"
              @click="selectItem(item)"
              @mouseEnter="hoverItem(item)"
            />
          </ul>
        </div>
      </Popper>
    </div>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue';
import { v4 as uuid } from 'uuid';

import Popper from '@/components/generic/popper.vue';
import UseSvg from '@/components/generic/use_svg.vue';
import SelectItem from '@/components/form/select_item.vue';

const props = defineProps({
  modelValue: { type: Object, default: null },
  list: { type: Array, default: () => [] },
  labelGroup: { type: Object, required: true, default: () => {} },
  modifiers: { type: Array, default: () => [] },
  placeholderAsValue: { type: Boolean, default: true },
  showIconsInList: { type: Boolean, default: false },
  labelIcons: { type: Object, default: null },
});
const emit = defineEmits(['update:modelValue']);

const open = ref(false);
const icon = computed(() => {
  if (props.modelValue && props.labelIcons) {
    return props.labelIcons[props.modelValue.value];
  }
  return null;
});

function newItem() {
  return {
    id: uuid(),
    isNew: true,
  };
}

function selectItem(item) {
  emit('update:modelValue', item);
  open.value = false;
}

function hoverItem(item) {
  emit('hover', item?.value || null);
}
</script>
